import  React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Introduction from "../components/introduction/introduction"
import Footer from "../components/footer/footer"
import ContentContainer from "../components/content-container/content-container"
import Events from "../components/events/events"
import Faqs from "../components/faq/faqs"
import { graphql } from "gatsby"
import Reminder from "../components/reminder/reminder"
import gif from '../images/JSUL_22_TEXT.mp4'
import JsLogo from "../icons/js-logo"
import Country from "../components/country/country"

const IndexPage = ({ data }) => {

  const events = {
    shopping: data.home.shopping,
    party: data.home.party,
    winnings: data.home.partyBagsWinnings
  }






  return (
    <Layout>
      <Seo title="James Street Uplate 2022" />
      <div className={ 'page--fade-in '}>
      <ContentContainer>
        <div className="flex justify-center pt-[250px] relative md:flex md:flex-col  md:pt-[120px]  ">
          <JsLogo className="js-logo md:relative md:mb-[120px] md:translate-x-0 z-20" />
          <div className="relative w-full max-w-[800px] z-10">
            <div className="pt-[100%]">
              <video  playsInline placeholder="" muted autoPlay loop className="m-w-[800px] bg-image" src={gif} />
            </div>
          </div>

        </div>
        <Introduction title={data.home.introduction} description={data.home.introductionDescription} eventDescription={data.home.eventsDescription} />
        <Events shopOnlineHeading={data.home.shopOnlineHeading} shopLinksEnabled={data.home.shopLinksEnabled} events={events} />
        <Faqs faqs={data.home.faq} />
        <Reminder />
      </ContentContainer>
      <Country />
      </div>
      <Footer />
    </Layout>)
}

export default IndexPage


export const query = graphql`
  query Homepage{
    home: datoCmsHomepage {
      shopLinksEnabled
      introductionDescription
      introduction
      eventsDescription
      shopOnlineHeading
      faq {
        featureImage {
        gatsbyImageData
      }
        description
        name
        direction
        link
        gradient{
            gatsbyImageData
            url
          }
          callToAction {
        text
        url
      }
      }
      shopping {
        ... on DatoCmsEvent{
          name
          model {
            apiKey
          }
          id
          availableOnline
          description
          linkText
          link
          showShopLink
          backgroundImage{
            gatsbyImageData
            url
          }
        }
        ... on DatoCmsDecoration{
          name
          id
          model {
            apiKey
          }
          backgroundImage{
            gatsbyImageData
            url
          }
        }
      }
      party {
        ... on DatoCmsEvent{
          name
          id
          model {
            apiKey
          }
          description
          linkText
          showShopLink
          link
          availableOnline
          backgroundImage{
            gatsbyImageData
            url
          }
        }
        ... on DatoCmsDecoration{
          name
          id
          model {
            apiKey
          }
          
          backgroundImage{
            gatsbyImageData
            url
          }
        }
      }
      partyBagsWinnings {
      ... on DatoCmsDecoration {
        name
        id
        
          model {
            apiKey
          }
         
          backgroundImage{
            gatsbyImageData
            url
          }
      }
      ... on DatoCmsWinning {
        name
        id
        featureImage {
        gatsbyImageData
      }
          model {
            apiKey
          }
          gradient{
            gatsbyImageData
            url
          }
          description
          link
          backgroundImage{
            gatsbyImageData
            url
          }
          callToAction {
        text
        url
      }
      }
      }
    }
  }
    
`
